import * as React from "react";
import { ButtonType, CustomButton, Table } from "soprasteria-ui-library";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { ORTHODONTIC_LKGCF_PATIENT_EXTENSION } from "../../../../utils/RouteConstants";
import { IOrthodonticLkgCfPatientExtension } from "../../../../models/IOrthodonticLkgCfPatientExtension";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";

interface IOrthodonticLkgCfPatientExtensionsTab {
    canCreateOrthodonticLkgCfPatientExtension: boolean;
    orthodonticLkgCfPatientExtensions: IOrthodonticLkgCfPatientExtension[];
}

export const OrthodonticLkgCfPatientExtensionsTab: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionsTab> = ({ canCreateOrthodonticLkgCfPatientExtension, orthodonticLkgCfPatientExtensions }) => {

    const match = useRouteMatch();

    const renderTableLink = (linkText: string, orthodonticLkgCfPatientExtension: IOrthodonticLkgCfPatientExtension) => {
        return <Link to={`${match.url}/${ORTHODONTIC_LKGCF_PATIENT_EXTENSION}/${orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionId}`}>{linkText}</Link>
    }

    return (
        <section>
            {
                canCreateOrthodonticLkgCfPatientExtension ?
                    <div className="panel text-right">
                        <Link to={{ pathname: `${match.url}/${ORTHODONTIC_LKGCF_PATIENT_EXTENSION}` }}><CustomButton buttonText="Ansök om förlänging av LKG/CF" buttonType={ButtonType.create} /></Link>
                    </div>
                    : null
            }
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Datum skickad</th>
                        <th>Mottagningens namn</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        orthodonticLkgCfPatientExtensions && orthodonticLkgCfPatientExtensions.length > 0 ?
                            orthodonticLkgCfPatientExtensions.map((orthodonticLkgCfPatientExtension, key) => {
                                return (
                                    <tr key={key} className="clickable-row">
                                        <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension.regDate ? dateTimeToDateString(orthodonticLkgCfPatientExtension.regDate) : "", orthodonticLkgCfPatientExtension)}</td>
                                        <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension.careProvider.name, orthodonticLkgCfPatientExtension)}</td>
                                        <td className="table-data-link">{renderTableLink(orthodonticLkgCfPatientExtension.orthodonticLkgCfPatientExtensionStatus, orthodonticLkgCfPatientExtension)}</td>
                                    </tr>
                                )
                            })
                            :
                            <tr><td colSpan={3}>Det finns inga ansökningar registrerade för den här patienten</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    )
}